import type { Contact } from '../../types/contact';
import type { ContactType } from '../../types/contact';
import type { ActivityFilters } from '../activity/types';

export const ContactSelectionMode = {
  CONTACT_VIEW: 'CONTACT_VIEW',
  SINGLE_CLIENT_SELECTION: 'SINGLE_CLIENT_SELECTION',
  MULTIPLE_CLIENT_SELECTION: 'MULTIPLE_CLIENT_SELECTION',
  SINGLE_PROVIDER_SELECTION: 'SINGLE_PROVIDER_SELECTION',
  MULTIPLE_PROVIDER_SELECTION: 'MULTIPLE_PROVIDER_SELECTION',
} as const;

export type ContactSelectionMode = typeof ContactSelectionMode[keyof typeof ContactSelectionMode];

export const isContactView = (mode: ContactSelectionMode): boolean =>
  mode === ContactSelectionMode.CONTACT_VIEW;

export const isSelectionMode = (mode: ContactSelectionMode): boolean =>
  mode !== ContactSelectionMode.CONTACT_VIEW;

export const isSingleSelection = (mode: ContactSelectionMode): boolean =>
  mode === ContactSelectionMode.SINGLE_CLIENT_SELECTION ||
  mode === ContactSelectionMode.SINGLE_PROVIDER_SELECTION;

export const isMultipleSelection = (mode: ContactSelectionMode): boolean =>
  mode === ContactSelectionMode.MULTIPLE_CLIENT_SELECTION ||
  mode === ContactSelectionMode.MULTIPLE_PROVIDER_SELECTION;

// Which contact types are visible in this mode
export function getTypeFilterForMode(mode: ContactSelectionMode): ContactType | undefined {
  switch (mode) {
    case ContactSelectionMode.SINGLE_CLIENT_SELECTION:
    case ContactSelectionMode.MULTIPLE_CLIENT_SELECTION:
      return 'CLIENT';
    case ContactSelectionMode.SINGLE_PROVIDER_SELECTION:
    case ContactSelectionMode.MULTIPLE_PROVIDER_SELECTION:
      return 'PROVIDER';
    default:
      return undefined;
  }
}

const contactTypeLabels: Record<ContactType, string> = {
  CLIENT: 'Клієнт',
  PROVIDER: 'Постачальник',
  BOTH: 'Клієнт і постачальник',
};

export const formatContactType = (type: ContactType): string => contactTypeLabels[type];

export interface ContactSelectionContext {
  mode: ContactSelectionMode;
  viewType?: ContactType; // for CONTACT_VIEW: which tab to show
  activityFeId?: string;
  currentContactId?: number;
  returnPath?: string;
  activityFilters?: ActivityFilters;
}

export interface ContactSelectionResult {
  selectedContact?: Contact;
  selectedContacts?: Contact[];
  activityFeId?: string;
}
